<script>
    import Icon from '../../../components/Icon.svelte';
    import AudioPlayer from '../../../components/AudioPlayer.svelte';
    import sessionStore from 'store/session';
    import InfiniteScroll from 'svelte-infinite-scroll';
    import { getContactName } from '../../../common/utils.js';
    import { getVoiceMessageNextPageAction } from 'domain/session/callLog.actions';
    import userStore from 'store/user';

    let search = '';
    let mobileID;

    let voice_messages = [];

    userStore.subscribe((value) => {
        mobileID = value.mobileID;
    });

    const groupByDate = (voice_messages) => {
        const groupedCalls = voice_messages.reduce((acc, voice_message) => {
            const date = new Date(
                voice_message.call_log?.start_time || voice_messages.date_created
            ).toDateString();
            if (!acc[date]) {
                acc[date] = [];
            }
            acc[date].push(voice_message);
            return acc;
        }, {});

        return Object.entries(groupedCalls).map(([date, voice_messages]) => ({
            date,
            voice_messages,
        }));
    };

    sessionStore.subscribe((session) => {
        session.voice_messages.results = session.voice_messages.results.map((item) => ({
            ...item,
            caller_name: getContactName(item.call_log?.recipient_number),
        }));

        let grouped_calls = groupByDate(session.voice_messages.results);

        voice_messages = { ...session.voice_messages, results: grouped_calls };
    });

    $: filtered_voice_messages = {
        ...voice_messages,
        results: voice_messages.results.map((item) => ({
            ...item,
            voice_messages: item.voice_messages.filter((voice_message) =>
                voice_message.caller_name.toLowerCase().includes(search.toLowerCase())
            ),
        })),
    };

    let page = 1;

    const fetchData = async () => {
        await getVoiceMessageNextPageAction(mobileID, page);
    };
</script>

<div id="call-history-recordings">
    <div class="row tab-content">
        <p class="text-red font-700">Recordings are parmanently deleted after 30 dates</p>

        <div class="search-box">
            <div class="icon search"><Icon icon="search" /></div>
            <input type="text" placeholder="Search by name" bind:value={search} />
        </div>
        {#if filtered_voice_messages.results && filtered_voice_messages.results.length > 0 }
            {#each filtered_voice_messages.results as recording}
                <p class="text-left w-100 date font-400 mt-0">{recording.date}</p>
                <ul class="calls-ul">
                    {#each recording.voice_messages as item}
                        <li class="padding-10">
                            <AudioPlayer sourceURL={item.recording_url} />

                            <div class="d-flex">
                                <div class="left">
                                    <p class="m-0 font-700">
                                        Call from: {item.caller_name}
                                    </p>
                                </div>
                                <div class="right">
                                    <p class="m-0 font-400 text-right">
                                        {new Date(
                                            item.call_log?.start_time || item.date_created
                                        ).toLocaleTimeString()}
                                        <Icon icon="keyboard-arrow-down" />
                                    </p>
                                </div>
                            </div>
                        </li>
                    {/each}
                </ul>
            {/each}
        {:else}
        <p class="text-left w-100 date font-400 mt-0">No record found</p>
        {/if}

        
        <InfiniteScroll
            hasMore={voice_messages.next !== null}
            threshold={5}
            on:loadMore={() => {
                page++;
                fetchData();
            }}
        />
    </div>
</div>

<style lang="scss">
    #call-history-recordings {
        .tab-content {
            padding: 0 0.75rem !important;
            display: block;
            max-height: 392px;
            overflow-y: scroll;
            .search-box {
                position: relative;
                .icon.search {
                    position: absolute;
                    top: 12px;
                    left: 15px;
                }
                input {
                    border: 1px solid #eeeeee;
                    border-radius: 4px;
                    padding: 12px 16px;
                    padding-left: 40px;
                    box-sizing: border-box;
                    width: 100%;
                    font-weight: 400;
                    font-size: 16px;
                    color: #35383f;
                }
            }
            .right p {
                color: #a7b4be;
                font-weight: 500;
                font-size: 14px;
            }
            .padding-bottom-10 .right p {
                color: #474b50;
                font-weight: 500;
                font-size: 12px;
            }
            .padding-bottom-10 .right {
                display: flex;
                align-items: center;
            }
            .left p {
                color: #35383f;
                font-weight: 500;
                font-size: 14px;
            }
            p {
                line-height: 1.5;
                font-size: 14px;
                span {
                    border-right: 1px solid #eeeeee;
                    font-size: 12px;
                }
                span:last-child {
                    border-right: 0px !important;
                }
            }
            .date {
                font-size: 14px;
                color: #607d8a;
            }
            .calls-ul {
                margin-top: 0px;
                padding: 0;
                list-style: none;
                li {
                    flex-direction: column;
                    background: #ffffff;
                    border: 1px solid rgba(17, 54, 69, 0.05);
                    border-radius: 12px;
                    padding: 17px;
                    margin-bottom: 8px;
                    .range-main {
                        .range-25 {
                            width: 25%;
                        }
                        .range-50 {
                            width: 50%;
                        }
                        .range-70 {
                            width: 75%;
                        }
                        .range-100 {
                            width: 100%;
                        }
                    }
                }
                .right {
                    p {
                        display: flex;
                    }
                }
                .left {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    input {
                        width: 90%;
                        height: 5px;
                    }
                }
                .range-main {
                    height: 5px;
                    background: #d9e2e7;
                    border-radius: 8px;
                    margin: 0 10px;
                    overflow: visible;
                    width: 100%;
                    .range {
                        background-color: #f3bf24;
                        height: 5px;
                        max-height: 8px;
                        width: 50%;
                        position: relative;
                        border-radius: 5px;
                    }
                    span {
                        background-color: #f3bf24;
                        float: right;
                        position: absolute;
                        right: -5px;
                        top: -5px;
                        width: 14px;
                        height: 14px;
                        border-radius: 50%;
                    }
                }
            }
        }

        .tab-content::-webkit-scrollbar {
            display: none;
        }
    }
</style>
